import { makeStyles } from "@material-ui/core/styles"
import { NavigationItemObject } from "app/navigationItems"
import React, { memo } from "react"
import { StyledList, StyledTapBar, StyledTapBarItem } from "./style"

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    backgroundColor: theme.palette.common.white,
  },
}))

function TapBar({ mobileNavigationItems }: { mobileNavigationItems: NavigationItemObject[] }) {
  const classes = useStyles()
  return (
    <StyledTapBar variant="permanent" anchor="bottom" classes={{ paper: classes.drawerPaper }}>
      <StyledList component="nav">
        {mobileNavigationItems.map(({ name, nameMobile, to, icon }) => (
          <StyledTapBarItem key={name} to={to} name={nameMobile || name} icon={icon} />
        ))}
      </StyledList>
    </StyledTapBar>
  )
}

export default memo(TapBar)
